import request from '@/utils/request'

// 查询客户收货地址列表
export function listAddr(data) {
  return request({
    url: '/server/addr/list',
    method: 'get',
    params: data
  })
}

// 修改客户收货地址
export function updateAddress(data) {
  return request({
    url: '/server/addr/edit',
    method: 'post',
    data: data
  })
}

// 新增客户收货地址
export function addAddress(data) {
  return request({
    url: '/server/addr/add',
    method: 'post',
    data: data
  })
}

// 设置默认客户收货地址
export function updateDefault(data) {
  return request({
    url: '/server/addr/default',
    method: 'post',
    data: data
  })
}

// 删除客户收货地址
export function delAddr(addrIds) {
  return request({
    url: `/server/addr/delete/${addrIds}`,
    method: 'post'
  })
}

// 获取客户收货地址详细信息
export function getAddr(addrId) {
  return request({
    url: `/server/addr/getInfo/${addrId}`,
    method: 'get'
  })
}
